import { useCallback } from 'react';

import { atom, useRecoilState } from 'recoil';

import { RandomHelper } from '#/utils/RandomHelper';

export interface SideModal {
  id: string;
  order: number;
}

const sideModalsAtom = atom<SideModal[]>({
  key: 'side-modals',
  default: []
});

export const useSideModals = () => {
  const [sideModals, setSideModals] = useRecoilState<SideModal[]>(sideModalsAtom);

  const addSideModal = useCallback(
    (modal: SideModal) => {
      setSideModals(current => [...current, { ...modal, order: current.length + 1 }]);
    },
    [setSideModals]
  );

  const removeSideModal = useCallback(
    (id: string) => {
      setSideModals(current =>
        current.filter(sideModal => sideModal.id !== id).map((sideModal, index) => ({ ...sideModal, order: index + 1 }))
      );
    },
    [setSideModals]
  );

  const newSideModal = useCallback(
    (id?: string): SideModal => ({
      id: id || RandomHelper.alphaNumeric(),
      order: sideModals.length + 1
    }),
    [sideModals.length]
  );

  return {
    sideModals,
    addSideModal,
    removeSideModal,
    newSideModal
  };
};
